import type {
  Badge,
  ListBadgesResponse,
} from '@wix/ambassador-badges-v3-badge/types';
import { withResolvedError } from '@wix/members-area-commons-ts';

import type { ErrorHandler, HttpClient } from '../../types/controller';

type BadgesServiceOptions = {
  baseUrl: string;
  httpClient: HttpClient;
  errorHandler: ErrorHandler;
};

export class BadgesService {
  private readonly baseUrl: string;
  private readonly httpClient: HttpClient;
  private readonly errorHandler: ErrorHandler;

  constructor({ baseUrl, httpClient, errorHandler }: BadgesServiceOptions) {
    this.baseUrl = baseUrl;
    this.httpClient = httpClient;
    this.errorHandler = errorHandler;
  }

  readonly getBadgeList = async (): Promise<Badge[]> => {
    const requestFn = () =>
      this.httpClient.get<ListBadgesResponse>(this.baseUrl);

    const { data } = await withResolvedError(requestFn, this.errorHandler, {
      errorCodesMap: {},
    });

    return data.badges ?? []
  };
}
